import { render, staticRenderFns } from "./PolicyFireRiskDetails.vue?vue&type=template&id=5a318106&"
import script from "./PolicyFireRiskDetails.vue?vue&type=script&lang=js&"
export * from "./PolicyFireRiskDetails.vue?vue&type=script&lang=js&"
import style0 from "./PolicyFireRiskDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports